import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

export const Wrapper = styled.div<{ isSubHeaderHidden: boolean; isNavCollapsed?: boolean }>`
  background: white;
  height: 4rem;
  box-shadow: 0 2px 3rem 0 rgba(0, 0, 0, 0.1);
  width: calc(100% - ${({ isNavCollapsed }) => (isNavCollapsed ? '4.5rem' : '13.125rem')});
  padding: 0 2.25rem;
  align-items: center;
  position: fixed;
  left: ${({ isNavCollapsed }) => (isNavCollapsed ? '4.5rem' : '13.125rem')};
  display: ${({ isSubHeaderHidden }) => (isSubHeaderHidden ? 'none' : 'flex')};
  justify-content: space-between;
  z-index: 27;

  @media all and (max-width: 64rem) {
    left: 0;
    width: 100%;
    top: 0;
  }

  & > div {
    padding: 0;
    display: flex;
    align-items: center;

    & > button {
      margin-left: 0.75rem;
    }
  }

  h2 {
    font-size: 1.25rem;
    font-weight: 900;
    line-height: 1.75rem;
  }
`

export const Separator = styled.div`
  height: 1.75rem;
  width: 1px;
  background: #e9e9e9;
  margin: 0 0.75rem;
`

export const SubHeaderNav = styled.nav`
  ul {
    display: flex;
    align-items: center;
    justify-content: center;

    li {
      cursor: pointer;
      color: ${colors.black1};
      list-style: none;
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.125rem;
      margin-right: 0.75rem;
      height: 30px;
      display: flex;
      align-items: center;

      /* stylelint-disable */
      &.active {
        color: white;
        background: ${colors.black1};
        border-radius: 0.5rem;
        padding: 0 0.75rem;
      }

      a {
        color: inherit;
        text-decoration: none;
      }
      /* stylelint-enable */
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/SubHeader/SubHeader.style.tsx